import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal/modal.component';
import { TranslocoRootModule } from 'projects/runner/src/app/transloco/transloco-root.module';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoRootModule,
    DialogModule,
    ButtonModule
  ],
  exports: [
    ModalComponent
  ]
})
export class CoreUiModule { }
